import { getConfig } from "../config.js";
function base(){ return getConfig().API_BASE || "https://trgpt.pythonanywhere.com/api"; }
async function j(r){ if(!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); }

// Capital & Equity
export async function getCapital(){ return j(await fetch(`${base()}/capital`)); }
export async function getCapitalHistory(){ return j(await fetch(`${base()}/capital_history`)); }
export async function getEquityData(period="month"){ return j(await fetch(`${base()}/equity-data?period=${period}`)); }
export async function getEquitySummary(period="month"){ return j(await fetch(`${base()}/equity-summary?period=${period}`)); }

// Performance
export async function getPerformance(period="month"){ return j(await fetch(`${base()}/performance?period=${period}`)); }

// Trades (optional)
export async function getTrades(){ try{ return j(await fetch(`${base()}/trades`)); }catch{ return []; } }

// Export
export async function exportCSV(table="trades", period="monthly", start, end){
  let url = `${base()}/export?table=${table}&period=${period}`;
  if (start) url += `&start=${encodeURIComponent(start)}`;
  if (end) url += `&end=${encodeURIComponent(end)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return await res.blob();
}

// Simulation
export async function simulateTrades(payload={}){
  return j(await fetch(`${base()}/simulate`,{
    method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify(payload)
  }));
}

// Bot controls
export async function resetBot(){ return j(await fetch(`${base()}/reset_bot`,{method:"POST"})); }
export async function abortTrade(data={}){
  return j(await fetch(`${base()}/abort_trade`,{
    method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify(data)
  }));
}

// Signals
export async function getSignalPreview(){ return j(await fetch(`${base()}/signal_preview`)); }
export async function rejectSignal(data={}){
  return j(await fetch(`${base()}/reject_signal`,{
    method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify(data)
  }));
}

// Health
export async function checkHealth(){ return j(await fetch(`${base()}/health`)); }

// add to your src/services/api.js or use as separate import
export async function runVirtualOnce(payload={}){
  const base = process.env.REACT_APP_API_URL;
  const r = await fetch(`${base}/virtual/run_once`,{
    method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify(payload)
  });
  if(!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}
export async function backtestVirtual(payload={}){
  const base = process.env.REACT_APP_API_URL;
  const r = await fetch(`${base}/virtual/backtest`,{
    method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify(payload)
  });
  if(!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}
